import { computed } from "vue";
import { useAccountStore } from "../stores/AccountStore";

/**
 * Read a dark launched feature's availability for the signed in user.
 *
 * Resolved server side, so this is true when the feature has been released to
 * everyone or when the user holds pilot access, including while they impersonate
 * another account.
 */
export function usePilotFlag(flagName) {
  const accountStore = useAccountStore();

  const isEnabled = computed(
    () => accountStore.user?.features?.pilot?.[flagName] === true
  );

  return { isEnabled };
}
